import { useEffect, useState } from "react";
import api, { apiError } from "../../lib/api";
import { toast } from "sonner";

export const DealNotesAdmin = ({ dealId }) => {
  const [notes, setNotes] = useState([]);

  const load = () => api.get(`/admin/deals/${dealId}/notes`).then((r) => setNotes(r.data)).catch(() => {});
  useEffect(() => { load(); }, [dealId]); // eslint-disable-line react-hooks/exhaustive-deps

  const download = async (n) => {
    try {
      const res = await api.get(`/admin/deals/${dealId}/notes/${n.note_id}/download`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = n.file_name; a.click();
      URL.revokeObjectURL(url);
    } catch (e) { toast.error(apiError(e)); }
  };

  const remove = async (n) => {
    if (!window.confirm("Remove this member note?")) return;
    try { await api.delete(`/admin/deals/${dealId}/notes/${n.note_id}`); toast.success("Note removed."); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="border border-[#24272B] p-4 my-6" data-testid="admin-deal-notes">
      <span className="t-label">Member notes, private ({notes.length})</span>
      <div className="mt-3 space-y-0">
        {notes.map((n) => (
          <div key={n.note_id} className="hairline py-4" data-testid={`admin-note-${n.note_id}`}>
            <p className="t-cap text-muted-s fig">{n.author_name} · {n.created_at?.slice(0, 10)}</p>
            {n.body && <p className="t-small text-bone whitespace-pre-wrap mt-1">{n.body}</p>}
            {n.link && <a href={n.link} target="_blank" rel="noreferrer" className="t-small text-tint underline break-all mt-1 block">{n.link}</a>}
            {n.file_name && <button className="t-small text-tint underline mt-1 block" onClick={() => download(n)}>{n.file_name}</button>}
            <button className="t-label hover:!text-[#E8E6E1] mt-2" onClick={() => remove(n)} data-testid={`admin-note-remove-${n.note_id}`}>Remove</button>
          </div>
        ))}
        {notes.length === 0 && <p className="t-small text-muted-s py-3">No member notes on this deal.</p>}
      </div>
    </div>
  );
};
